// extracted by mini-css-extract-plugin
export default {"breadCrumbs":"property-detail-header_breadCrumbs__oj+o0","back":"property-detail-header_back__8SWVr","divider":"property-detail-header_divider__R9tWc"};